

var ResponsiveTable = (function ($) {
  var flag = false;

  var delay = 400;

  var $wrapper = $('.wrapper');

  var $tableRow = $('.responsive-table tbody tr');

  var $tableMobileHeader = $('.responsive-table-header-mobile ul li');

  var $tableCol = $('.responsive-table tbody > '
      + 'tr.responsive-table-body:nth-child(2) td');

  var widhtFirstColumnBody = $('.responsive-table-static tbody > '
      + '.responsive-table-body:visible .responsive-table-fixed-column')
    .width() - 8;

  function init(stickyHeader) {
    var initStickyHeader = (stickyHeader !== undefined) ? stickyHeader : true;

    flag = false;

    delay = 400;

    $tableRow = $('.responsive-table tbody tr');

    $tableMobileHeader = $('.responsive-table-header-mobile ul li');

    $tableCol = $('.responsive-table tbody > '
        + 'tr.responsive-table-body:nth-child(2) td');

    widhtFirstColumnBody = $('.responsive-table-static tbody > '
        + '.responsive-table-body:visible .responsive-table-fixed-column')
      .width() - 8;

    $('.responsive-table-info').each(function () {

      if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
        var spanToChange = $(this).find('span');
        $(spanToChange).css('display', 'block');
      }

      $(this).on('click', function (e) {
        var anchor = this;

        e.preventDefault();

        $(this).attr('href', '#');

        $.get($(this).data('href') + '?stub=1', function (data) {
          var $collapseContent = $('#' + $(anchor).attr('aria-controls')
            + ' .collapse-content').get(0);

          $collapseContent.innerHTML = data;

          setTimeout(function () {

            $('#' + $(anchor).attr('aria-controls')).collapse('toggle');

            if ($('html').hasClass('ie')) {

              setTimeout(waitImage, 400, $($collapseContent));

            } else {

              Acr.Disclaimer.init();

            }

          }, 200);
        });
      });

      $(this).on('mousedown', function (e) {
        var href = $(this).data('href');

        if (e.which === 3) {
          $(this).attr('href', href);
        }
      });
    });

    $tableRow.find('td.col-1').show().addClass('active');

    $tableMobileHeader.eq(0).addClass('active');

    $tableMobileHeader.on('click', function (event) {
      if (!flag && !$(this).hasClass('active')) {
        $('li').removeClass('active');

        $(this).addClass('active');

        toggleColumn($(this).index());

        flag = true;
      }

      if ($('.responsive-table-detail .collapse.in')) {
        $('.responsive-table-detail .collapse').collapse('hide');
      }
    });

    var resizeFunc = Utility.debounce(function () {
      widhtFirstColumnBody = $('.responsive-table-static tbody > '
          + '.responsive-table-body:visible .responsive-table-fixed-column')
        .width() - 8;

      removeAttrStyle();
      // scrollTitleSticky();
      widthFirstColumnSubcategory();
    }, 10);

    $(window).resize(resizeFunc);

    if (initStickyHeader === true) {
      $(window).scroll({ elementLabel: 'window' },
        $.throttle(100, scrollHandler));

      $('.modal-body').scroll({ elementLabel: 'modal-body' },
        $.throttle(100, scrollHandler));
    }

    countCol();

    closeDetails();

    toggleAccordion();

    if (!(window.ActiveXObject) && 'ActiveXObject' in window) {
      waitImage($('.table.responsive-table-static thead'), false);
    }
  } // init END

  function scrollHandler(event) {
    Utility.log('SCROLLING: throttle(250) from ResponsiveTable ('
      + event.data.elementLabel + ')');
    scrollHeaderSticky();
    // scrollTitleSticky();
  }

  function scrollDestroy() {
    $(window).off('scroll', scrollHandler);
    $('.modal-body').off('scroll', scrollHandler);
  }

  function countCol() {
    var colCount = 0;

    $tableCol.each(function () {
      colCount++;
    });

    $('.responsive-table-colspan').attr('colspan', colCount);
  }

  function closeDetails() {
    $tableRow.find('.responsive-table-detail-close').on('click', function (e) {
      e.preventDefault();

      var $this = $(this);

      var $collapse = $this.closest('.collapse');

      $collapse.collapse('toggle');
    });
  }

  function hideCol(target) {
    $(target).removeClass('active');

    $(target).fadeOut(delay);
  }

  function removeAttrStyle() {
    if ($(window).width() > 550) {
      $tableRow.find('td').removeAttr('style');
    }
  }

  function scrollHeaderSticky() {
    var itIsPresent = $(document).find('.responsive-table-static thead');

    if (itIsPresent.length > 0) {
      var headerHeight = $('.responsive-table-static thead').height();

      var headerPosition = $('.responsive-table-static thead').position().top;

      var scrollWindowTop = $(window).scrollTop();

      var tablePositionTop = $('.responsive-table-static').position().top;

      var tableHeight = $('.responsive-table-static').height();

      var headerPositionWithoutModal = $('.responsive-table-static thead')
        .offset().top - scrollWindowTop;

      var mlpNavHeight = $(document).find('.mlp-nav').outerHeight() - 1 || 0;
      var wraperHeight = $(document).find('.acr-nav__wrapper').outerHeight() - 1 || 0;

      var modalHeaderHeight = $('.modal-header').outerHeight();

      var negativeValueHeight = (modalHeaderHeight) ? -(headerHeight)
        : -(headerPositionWithoutModal + mlpNavHeight);

      var iOS = /iPad|iPhone|iPod|Safari/.test(navigator.userAgent)
          && /Apple Computer/.test(navigator.vendor) && !window.MSStream;

      if (($('.responsive-table-static tbody > '
          + '.responsive-table-body:visible').length) > 0) {
        if ($('.modal-body .responsive-table').length > 0) {
          if (headerPosition < negativeValueHeight) {
            if (iOS) {
              var stickyHeader = $('.responsive-table-header-sticky-container');

              $('.modal-content').append(stickyHeader);

              $('.responsive-table-header-sticky-container').css({
                display: 'block',
                position: 'fixed',
                left: 0,
                'max-height': '100px',
                top: modalHeaderHeight,
              });

              $('.acr-trim-header').css({
                opacity: 0,
              });
            } else {
              $('.responsive-table-header-sticky-container').css({
                display: 'block',
                left: 0,
                top: modalHeaderHeight,
              });

              $('.acr-trim-header').css({
                opacity: 0,
              });
            }

            widthFirstColumnSubcategory();
          } else {
            $('.responsive-table-header-sticky-container')
              .css('display', 'none');

            $('.acr-trim-header').css({
              opacity: 1,
            });
          }
        } else if (headerPositionWithoutModal <= negativeValueHeight) {
          if ($wrapper.hasClass('expanded-nav')) {
            $('.responsive-table-header-sticky-container').css({
              display: 'block',
              top: mlpNavHeight + wraperHeight,
            });
              
          } else {
            $('.responsive-table-header-sticky-container').css({
              display: 'block',
              top: mlpNavHeight,
            });
          }
          if (scrollWindowTop >= tablePositionTop + tableHeight) {
            $('.responsive-table-header-sticky-container')
              .css('display', 'none');
          }

          $('.acr-trim-header').css({
            opacity: 0,
          });

          widthFirstColumnSubcategory();
        } else {
          $('.responsive-table-header-sticky-container')
            .css('display', 'none');

          $('.acr-trim-header').css({
            opacity: 1,
          });
        }
      } else {
        $('.responsive-table-header-sticky-container').css('display', 'none');

        $('.acr-trim-header').css({
          opacity: 1,
        });
      }
    } else {
      scrollDestroy();
    }
  }

  function scrollTitleSticky() {
    var scrollWindowTop = $(window).scrollTop();
    var buttonData = $('.responsive-table-title-accordion h4.active');
    var elementPosition = 0;
    var subtraction = 0;
    var $grandparentElement = '';
    var stickyHeaderHeight = $('.responsive-table-header-sticky-container')
      .outerHeight();
    var headerHeight = $('.responsive-table-static thead').height();
    var negativeValueHeight = -(headerHeight);

    $.each(buttonData, function (k, v) {
      elementPosition = $(v).position().top;
      subtraction = elementPosition - scrollWindowTop;
      $grandparentElement = $(v).parents('.responsive-table-title-accordion');

      if (subtraction <= 0 && !$grandparentElement.hasClass('fixed')) {
        $('.responsive-table-title-accordion').removeClass('fixed');
        $grandparentElement.addClass('fixed').css('top', stickyHeaderHeight);
      } else if (subtraction >= negativeValueHeight
                  && $grandparentElement.hasClass('fixed')) {
        $grandparentElement.removeClass('fixed');
      }
    });
  }

  function showCol(target) {
    $(target).addClass('active');

    $(target).css({
      opacity: 0,
      display: 'table-cell',
    });

    $(target).animate({
      opacity: 1,
    }, delay);

    setTimeout(function () {
      flag = false;
    }, delay + 1);
  }

  function toggleAccordion() {
    var $button = $('.responsive-table-title-accordion-link');

    var buttonData = '';

    var $firstAnchor = $('.responsive-table-title-accordion').eq(0).find('h4');

    $('.responsive-table-body, .responsive-table-detail').hide();

    if ($firstAnchor.hasClass('expanded')) {
      $firstAnchor.addClass('active');

      buttonData = $firstAnchor.data('section');

      $('.' + buttonData).removeAttr('style');
    }

    $button
      .off('click')
      .on('click', function (e) {
        buttonData = $(this).find('h4').data('section');

        if ($(e.target).closest('.disclaimer-callout').length === 0) {
          if ($('tr.' + buttonData).is(':visible')) {
            $('tr.' + buttonData).hide();

            $(this).find('h4').removeClass('active');
          } else {
            $(this).find('h4').addClass('active');

            $('.' + buttonData).removeAttr('style');
          }
        }
      });

    $button.eq(0).trigger('click');
  }

  function toggleColumn(index) {
    var indexCol = index + 1;

    var targetCol = $tableRow.find('td.active');

    var target = $tableRow.find('td.col-' + indexCol);

    hideCol(targetCol);

    setTimeout(function () {
      showCol(target);
    }, delay);
  }

  function widthFirstColumnSubcategory() {
    var widhtFirstColumnBody = $('.responsive-table-static tbody > '
        + '.responsive-table-body:visible .responsive-table-fixed-column')
      .width();

    var widthTable = $('.responsive-table-static').width();

    $('.responsive-table-header-sticky').width(widthTable);

    $('.responsive-table-header-sticky thead tr '
        + 'th.responsive-table-fixed-column').width(widhtFirstColumnBody);
  }

  function waitImage($collapseContent, useBP) {
    if ($collapseContent.find('img').length) {
      var src;
      var srcset;
      var newSrc;
      var breakPImages;
      var image = new Image();
      var bpCurrent = getCurrentBreakpoint();

      useBP = (useBP !== undefined) ? useBP : true;

      if (useBP) {
        switch (bpCurrent) {
          case 'sm': breakPImages = $collapseContent.find('source[media|="(min-width: 550px)"]');
            break;
          case 'lg': breakPImages = $collapseContent.find('source[media|="(min-width: 1024px)"]');
            break;
          case 'xl': breakPImages = $collapseContent.find('source[media|="(min-width: 1400px)"]');
            break;
          default: breakPImages = $collapseContent.find('img');
            break;
        }
      } else {
        breakPImages = $collapseContent.find('img');
      }

      srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');
      src = breakPImages.attr('src') || breakPImages.attr('data-src');

      newSrc = srcset ? srcset.split(',') : src.split(',');
      newSrc = newSrc[0];


      $collapseContent.find('img').attr('src', newSrc);

      image.onload = function () {
        Acr.Disclaimer.init();
      };

      image.src = newSrc;

    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  return {
    init: init,
    destroy: scrollDestroy,
  };
}(jQuery));
